import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import Editor from "../../components/Editor";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Services = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [categoryname, setcategoryname] = useState("");
    const [categorytype, setcategorytype] = useState("Movie");
    const [description, setdescription] = useState("");
    const [categoryimage, setcategoryimage] = useState("");
    const [selectedid, setselectedid] = useState(0);

    const [name, setname] = useState("");

    const [title, settitle] = useState("");
    const [subtitle, setsubtitle] = useState("");
    const [image, setimage] = useState("");
    const [points, setpoints] = useState([]);


    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;

    const [editorLoaded, setEditorLoaded] = useState(true);

    var prevtableobj = [
      {
        "title": "",
        "file": null
      }
    ];

    const [tabledataarr, settabledataarr] = useState(prevtableobj);

    const tabledataarrRef = useRef(prevtableobj);
    tabledataarrRef.current = tabledataarr;

    const [forceupdate, setforceupdate] = useState(false);



    const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);

  const handleplusicon = () => {
    var prevobj = 
      {
        "title": "",
        "file": null
      };
    var prevdata = tabledataarrRef.current;
    prevdata.push(prevobj);
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const handleminusicon = () => {
    var prevdata = tabledataarrRef.current;
    if(prevdata?.length == 1) {

    } else {
      prevdata.pop();
      settabledataarr(prevdata);
      setforceupdate(!forceupdate);
    }
   
  }

  const handleinputtablechange = (index, key, value) => {
    var prevdata = tabledataarrRef.current;
    prevdata[index][key] = value;
    settabledataarr(prevdata);
    setforceupdate(!forceupdate);
  }

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const handleinputchange = async (file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    // console.log('obj >>', obj);
    setimage(obj);
  };

  const handleimagetablechange = async (index, key, file) => {
    var obj = {};
    await getBase64(file).then((result) => {
      obj["name"] = file.name;
      obj["image"] = result;
    });
    handleinputtablechange(index, key, obj);
    // console.log('obj >>', obj);
    // setimage(obj);
  };

  const submithandle = async () => {
    if (title) {
      setshowloding(true);
      var data = {
        title: title,
        subtitle: subtitle,
        image: image,
        points: points ? points.join(', ') : "",
        tabledata: tabledataarrRef.current
    };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "newservice", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            setshowmodal(false);
            settitle("");
            setsubtitle("");
            setpoints([]);
            setimage("");
            fetchallcourses();
            setshowloding(false);
          } else {
            if(res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} })
              navigate('/admin/login');
            } else {
                alert(res.data.message);
            }
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      alert("Empty Field");
    }
  };

  const edithandle = async () => {
    
    console.log('selectedidRef.current >>', selectedidRef.current);
      if (title ) {
        setshowloding(true);
        var data = {
          id: selectedidRef.current,
          title: title,
        subtitle: subtitle,
        image: image,
        points: points ? points.join(', ') : "",
        tabledata: tabledataarrRef.current
      };
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "updateservice", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              seteditshowmodal(false);
              settitle("");
              setsubtitle("");
              setpoints([]);
              setimage("");
              setselectedid(0);
              fetchallcourses();
              setshowloding(false);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
        setshowloding(false);
      } else {
        alert("Empty Field");
      }
    };

    const clickhandle = () =>  {
        // console.log('Mission Launched')
      }

      const editlocation = async(data) => {
        setselectedid(data?.id);
        console.log('editlocation data >>', data);
        settitle(data?.title);
        setsubtitle(data?.subtitle);
        if(data?.points) {
          setpoints(data?.points.split(','));
        } else {
          setpoints([])
        }

        if(data?.tabledata) {
          var prevdata = JSON.parse(data?.tabledata);
          settabledataarr(prevdata)
        } else {
          settabledataarr(prevtableobj)
        }
        // setname(data?.name);
        seteditshowmodal(true);
      }

      const deletecourse = async (id, title) => {
        console.log('id >>', id);
        const result = window.confirm("Are you sure you want to delete service " + title);
        if (result) {
          var data = JSON.stringify({
            id: id,
          });
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          let resp = await axios
            .post(apiUrl + "deleteservice", data, headers)
            .then((res) => {
              if (res.data.status == "success") {
                fetchallcourses();
              } else {
              }
            })
            .catch((err) => {
              alert(err.message);
            });
        } else {
          // User clicked Cancel or closed the dialog
          // console.log("User clicked Cancel");
        }
      };

      const defaultColDef = {
        flex: 1,
      };

      const handlesubmitquestion = () => {
        console.log('hello world!!');
      }

      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm("Are you sure you want to disable service " + title);
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updateservicestatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/admin/login');
        } else {
          alert(res.data.message);
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }


    const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "getallservices", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'points', 'tabledata', 'subtitle'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    obj.field = columns[i];
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }
               

                //Image
                if(columns.includes('image')) {
                  var imageobj = 
              {
                field: "Image",
                headerName: "Image",
                cellRenderer: (props) => {
                  // console.log('image props >>', props);
                  return (
                    <>
                    {
                        props?.data?.image ? 
                        <Link
                    to={assetsUrl+'services/'+props?.data?.image}
                    target="_blank"
                    style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                  >
                    <FontAwesomeIcon
                      icon={faEye}
                      className="sidebaricons"
                      style={{ color: "blue" }}
                    />
                  </Link> : null
                    }
                    </>
                    
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(imageobj);
                }

                //created_at
            //     if(columns.includes('created_at')) {
            //       var craetddatobj = 
            //   {
            //     field: "Date",
            //     headerName: "Date",
            //     cellRenderer: (props) => {
            //       // console.log('date props >>', props);
            //       return (
            //              <div>
            //               <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(craetddatobj);
            //     }

                 //status
             var statusobj = {
                field: "status",
                headerName: "Status",
                cellRenderer: (props) => {
                   // console.log('props >>', props?.data)
                   return (
                    <div className="d-flex">
                      <div class="form-check">
                        <input
                        onChange={(t) => {handleCheckboxChange(t, props?.data?.id, props?.data?.title)}}
                          type="checkbox"
                          class="form-check-input tableformcheck"
                          id="check1"
                          name="option1"
                          value="something"
                          style={{marginTop: 12}}
                          checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
                        />
                      </div>
                    </div>
                  );
                },
              };
              columnsarr.push(statusobj);
              
                //edit
              var editobj = 
              {
                field: "edit",
                headerName: "Edit",
                cellRenderer: (props) => {
                  
                  return (
                    <div
                          onClick={() => {
                            editlocation(props?.data);
                            // console.log('props >>', props?.data);
                          }}
                          style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="sidebaricons"
                            style={{ color: "blue" }}
                          />
                        </div>
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(editobj);

                //delete
                var deleteobj = 
                {
                  field: "delete",
                  headerName: "Delete",
                  cellRenderer: (props) => {
                    
                    return (
                      <div
                            onClick={() => {
                              deletecourse(props?.data?.id, props?.data?.title);
                              // console.log('props >>', props?.data);
                            }}
                            style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="sidebaricons"
                              style={{ color: "red" }}
                            />
                          </div>
                    )
                  },
                  cellRendererParams: {
                    onClick: clickhandle,
                  },
                }
                columnsarr.push(deleteobj);
                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              // alert(res.data.message);
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/admin/login');
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
      };
    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/admin/login");
            }
          }, []);
    return (
      <div className="adminmainpagelayout">
        <div className="productstogglebar mt-2">
          <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              setcategoryname("");
              setdescription("");
              settitle("");
              setsubtitle("");
              setimage("");
              setpoints([]);
              settabledataarr(prevtableobj);
              setshowmodal(true);
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>Add Service</p>
          </div>
        </div>

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 500, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/*Add modal */}
        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="lg"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>New Service</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Service Title"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Subtitle</label>
                {/* <input
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Service Sub-Title"
                /> */}
                {/* <textarea
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Service Sub-Title"
                ></textarea> */}
                <Editor
                  name="subtitle"
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t);
                  }}
                  editorLoaded={editorLoaded}
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Image</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control addproductinput"
                  placeholder="Category Image"
                />
              </div>
              {/* <div className="mt-3">
                <label className="addproduct-label">
                  Points (Type point and press enter to add another point)
                </label>
                <TagsInput
                  value={points}
                  onChange={(options) => {
                    setpoints(options);
                  }}
                  placeholder={"Enter Points"}
                  inputProps={{
                    className: "react-tagsinput-input",
                    placeholder: "",
                  }}
                  className="form-control tagsinputbox"
                />
              </div> */}
              <div className="mt-4">
                <div
                  className="d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="addproduct-label">Details Table</p>
                  <div className="d-flex">
                    <div
                      className="tableplusicon"
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        handleplusicon();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPlus}
                        className="iconstyles"
                        style={{ color: "#64748B" }}
                      />
                    </div>
                    <div
                      className="tableplusicon"
                      onClick={() => {
                        handleminusicon();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faMinus}
                        className="iconstyles"
                        style={{ color: "#64748B" }}
                      />
                    </div>
                  </div>
                </div>
                <table className="table table-bordered mt-2">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Title</th>
                      <th>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tabledataarrRef.current?.length > 0
                      ? tabledataarrRef.current?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div className="">
                                  <input
                                    value={item?.title}
                                    onChange={(t) => {
                                      handleinputtablechange(
                                        index,
                                        "title",
                                        t.target.value
                                      );
                                    }}
                                    type="text"
                                    className="form-control addproductinput"
                                    placeholder="Enter Title"
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="">
                                  <input
                                    onChange={(t) => {
                                      handleimagetablechange(
                                        index,
                                        "file",
                                        t.target.files[0]
                                      );
                                    }}
                                    accept=".pdf, .doc, .docx"
                                    type="file"
                                    className="form-control addproductinput"
                                    placeholder=" Image"
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    submithandle();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*Edit modal */}
        <Modal
          show={editshowmodal}
          onHide={() => seteditshowmodal(false)}
          size="lg"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Edit Service</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Title</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Service Title"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Subtitle</label>
                {/* <textarea
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Service Sub-Title"
                ></textarea> */}
                <Editor
                  name="subtitle"
                  value={subtitle}
                  onChange={(t) => {
                    setsubtitle(t);
                  }}
                  editorLoaded={editorLoaded}
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Image</label>
                <input
                  onChange={(t) => {
                    handleinputchange(t.target.files[0]);
                  }}
                  accept="image/*"
                  type="file"
                  className="form-control addproductinput"
                  placeholder="Category Image"
                />
              </div>
              {/* <div className="mt-3">
                <label className="addproduct-label">
                  Points (Type point and press enter to add another point)
                </label>
                <TagsInput
                  value={points}
                  onChange={(options) => {
                    setpoints(options);
                  }}
                  placeholder={"Enter Points"}
                  inputProps={{
                    className: "react-tagsinput-input",
                    placeholder: "",
                  }}
                  className="form-control tagsinputbox"
                />
              </div> */}
              <div className="mt-4">
                <div
                  className="d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <p className="addproduct-label">Details Table</p>
                  <div className="d-flex">
                    <div
                      className="tableplusicon"
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        handleplusicon();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPlus}
                        className="iconstyles"
                        style={{ color: "#64748B" }}
                      />
                    </div>
                    <div
                      className="tableplusicon"
                      onClick={() => {
                        handleminusicon();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faMinus}
                        className="iconstyles"
                        style={{ color: "#64748B" }}
                      />
                    </div>
                  </div>
                </div>
                <table className="table table-bordered mt-2">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Title</th>
                      <th>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tabledataarrRef.current?.length > 0
                      ? tabledataarrRef.current?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div className="">
                                  <input
                                    value={item?.title}
                                    onChange={(t) => {
                                      handleinputtablechange(
                                        index,
                                        "title",
                                        t.target.value
                                      );
                                    }}
                                    type="text"
                                    className="form-control addproductinput"
                                    placeholder="Enter Title"
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="">
                                  <input
                                    onChange={(t) => {
                                      handleimagetablechange(
                                        index,
                                        "file",
                                        t.target.files[0]
                                      );
                                    }}
                                    accept=".pdf, .doc, .docx"
                                    type="file"
                                    className="form-control addproductinput"
                                    placeholder=" Image"
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    edithandle();
                  }}
                >
                  <p>Update</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
}

export default Services